import React, { FC } from 'react';
import orderBy from 'lodash/orderBy';

import { IPunchDTO } from 'src/api/dtos';
import { PunchItem } from 'src/features/punches/PunchItem';
import { Drawer, EmptyState } from 'src/shared/components';
import { useTranslate } from 'src/shared/providers';

interface Props {
  recentPunches: IPunchDTO[];
  open: boolean;
  onClose: () => void;
}

export const RecentPunchesDrawer: FC<Props> = ({ open, recentPunches, onClose }) => {
  const { t } = useTranslate();
  const orderedList = orderBy(recentPunches, 'punchTimestamp', 'desc');

  return (
    <Drawer
      title={t('punches.recentPunches')}
      description={t('punches.belowAreThePunchesThatYouRecentlySubmitted')}
      open={open}
      onClose={onClose}
    >
      {orderedList.length > 0 ? (
        orderedList.map((item, index) => <PunchItem punch={item} key={index} />)
      ) : (
        <EmptyState title={t('punches.noPunchesYet')} message={t('punches.youDoNotHaveAnyRecentPunchesInTheSystem')} />
      )}
    </Drawer>
  );
};
